import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { isMobileDevice } from "../../Utils/Utils";
import { IconType } from "react-icons/lib/esm/iconBase";

interface SidebarState {
  isOpen: boolean;
  location: string;
  items: SidebarItem[];
}

export interface SidebarItem {
  label: string;
  icon: IconType;
  route?: string;
  children?: SidebarItem[];
  showChildren?: boolean;
  customerRequired?: boolean;
  superOnly?: boolean;
}

const initialState: SidebarState = {
  isOpen: !isMobileDevice(),
  location: "/",
  items: [],
};

export const sidebarChange = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setLocation: (state, action: PayloadAction<string>) => {
      state.location = action.payload;
    },
    setItems: (state, action: PayloadAction<SidebarItem[]>) => {
      state.items = [...action.payload];
    },
    clearSidebar: (state) => {
      return { ...initialState };
    },
  },
});

export const { setOpen, setLocation, setItems, clearSidebar } =
  sidebarChange.actions;

export default sidebarChange.reducer;
